var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationMapIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.46 6.83301L12.4668 6.83984L14.0068 14.0068H2L3.54004 6.83984H5.40039C5.58037 7.17314 5.78015 7.51321 5.9668 7.83984V8.64648C5.9668 9.35978 6.33996 10.0868 7.18652 10.0869H8.16016C9.80675 10.087 11.1401 11.3801 11.2334 13H12.7666L11.6533 7.83301H10.04C10.2267 7.50642 10.4197 7.16625 10.5996 6.83301H12.46ZM4.33984 7.83301L3.23438 12.9932H10.2266C10.1331 11.9266 9.24659 11.0801 8.15332 11.0801H7.17969C5.89318 11.0799 4.95996 10.0529 4.95996 8.63965V7.83301H4.33984ZM8 1.33301C9.42667 1.33301 10.5938 2.49342 10.5938 3.92676C10.5937 4.46654 10.4004 4.98638 10.3203 5.18652C9.88031 6.25319 8.48676 8.48674 8.42676 8.58008L8 9.25977L7.57324 8.58008C7.5532 8.54668 7.36675 8.24628 7.12012 7.83301C6.65345 7.06633 5.96633 5.87979 5.67969 5.18652C5.59963 4.98634 5.40725 4.45983 5.40723 3.92676C5.40723 2.50012 6.57337 1.33305 8 1.33301ZM8 2.33301C7.12003 2.33305 6.40625 3.04678 6.40625 3.92676C6.40627 4.16668 6.48652 4.49991 6.60645 4.7998C6.87311 5.44647 7.55333 6.60685 8 7.35352C8.44667 6.60685 9.12689 5.4398 9.39355 4.7998C9.52015 4.50656 9.59373 4.16669 9.59375 3.92676C9.59375 3.04676 8.88 2.33301 8 2.33301Z",
    fill: "#7D7D7D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationMapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Location_Map_Icon.b9913aeb4726142379e800c5958f9124.svg";